export default __webpack_public_path__ + "static/media/banner-4.3f6c2ba1.jpg";